/** @format */

import { useActiveKeys } from '@/entities/active-keys/model'
import { useTheme } from '@/entities/theme/model'
import { getCookie, setCookie } from '@/shared/lib/formatter'
import { useSafeNavigate } from '@/shared/lib/safe-navigate'
import {
  AccountingDarkIcon,
  CloudsDarkIcon,
  FundIcon,
  GateDarkIcon,
  IncomeDocsDarkIcon,
  LogisticsGrayIcon,
  ProductionGrayIcon,
  SalesIcon,
  SupplyDarkIcon,
  WarehouseDarkIcon,
} from '@/shared/ui/icons'
import { useTranslation } from 'react-i18next'
import ShortcutButton from '../../../ShortCuts'
import { GridContainer, GridSection, GridSection2 } from './style'
const HomeTop = () => {
  const { t } = useTranslation()
  const navigate = useSafeNavigate()
  const { theme } = useTheme()
  const { initialActiveKeys } = useActiveKeys()
  const token = getCookie('token')
  const themeCookie = getCookie('themeName')
  const handleClickShortcut = (titleKey: any, path: any) => {
    const modifiedActiveKeys = initialActiveKeys.map((item) => ({
      ...item,
      titleKey: item.titleKey || item.title || 'main',
      title: undefined, // Don't store translated title
    }))

    // Extract the segment from path for originalSegment
    const pathSegments = path.split('/').filter(Boolean)
    const lastSegment = pathSegments[pathSegments.length - 1] || ''

    if (token) {
      setCookie(
        'breadcrumb_items',
        JSON.stringify([
          ...modifiedActiveKeys,
          {
            titleKey: titleKey,
            path: path,
            originalSegment: lastSegment,
            isId: false,
          },
        ]),
        7,
      )
      navigate(path)
      setCookie('currentPath', path, 1)
    } else {
      setCookie('targetUrl', path, 1)
      setCookie(
        'breadcrumb_items',
        JSON.stringify([
          ...modifiedActiveKeys,
          {
            titleKey: titleKey,
            path: path,
            originalSegment: lastSegment,
            isId: false,
          },
        ]),
        7,
      )
      navigate('/login')
      setCookie('currentPath', '/login', 1)
    }
  }

  return (
    <GridContainer>
      <GridSection amount={2}>
        <ShortcutButton
          label={t('warehouse')}
          icon={
            // themeCookie === 'dark' ? (
            <WarehouseDarkIcon width='117px' height='48px' />
          }
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='230px'
          height='120px'
          iconwidth='117px'
          iconheight='48px'
          onClick={() => handleClickShortcut(t('warehouse'), '/warehouse/stocks-management')}
          isOnProcess={false}
        />
        <ShortcutButton
          label={t('supplying')}
          icon={<SupplyDarkIcon width='113px' height='57px' />}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='230px'
          height='120px'
          iconwidth='113px'
          iconheight='57px'
          onClick={() => handleClickShortcut(t('supplying'), '/supply')}
          isOnProcess={false}
        />
        <ShortcutButton
          label={t('sales')}
          icon={<SalesIcon width='113px' height='90px' />}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='230px'
          height='120px'
          onClick={() => handleClickShortcut(t('sales'), '/sales')}
          iconwidth='113px'
          iconheight='90px'
          isOnProcess={false}
        />
        <GridSection2>
          <ShortcutButton
            label={t('gate')}
            icon={<GateDarkIcon width='64px' height='64px' />}
            badgeIcon={null}
            badgeCount={0}
            bgColor={theme.mainPageActiveShortcutButtonBackground}
            textColor={theme.mainPageActiveShortcutButtonText}
            width='113px'
            height='120px'
            onClick={() => handleClickShortcut(t('gate'), '/gate')}
            isOnProcess={false}
            isMini={true}
          />
          <ShortcutButton
            label={t('accounting')}
            icon={<AccountingDarkIcon width='64px' height='64px' />}
            badgeIcon={null}
            badgeCount={0}
            bgColor='transparent'
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => handleClickShortcut(t('accounting'), '/accounting')}
            isOnProcess={false}
            isMini={true}
          />
        </GridSection2>
        <GridSection2>
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor={theme.mainPageInactiveShortcutButtonBackground}
            textColor={theme.mainPageInactiveShortcutButtonText}
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor='transparent'
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
        </GridSection2>
      </GridSection>
      <GridSection amount={2}>
        <ShortcutButton
          label={t('production')}
          icon={<ProductionGrayIcon width='119px' height='88px' />}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='230px'
          height='120px'
          iconwidth='119px'
          iconheight='88px'
          onClick={() => handleClickShortcut(t('production'), '/production')}
          isOnProcess={false}
        />
        <ShortcutButton
          label={t('transportation')}
          icon={<LogisticsGrayIcon width='109px' height='83px' />}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageInactiveShortcutButtonText}
          width='230px'
          height='120px'
          iconwidth='109px'
          iconheight='83px'
          onClick={() => handleClickShortcut(t('transportation'), '/')}
          isOnProcess={true}
        />
        <GridSection2 amount={2}>
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor={theme.mainPageInactiveShortcutButtonBackground}
            textColor={theme.mainPageInactiveShortcutButtonText}
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor='rgba(255, 255, 255, 0.32)'
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />

          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor=''
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor=''
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
        </GridSection2>
        <GridSection2 amount={2}>
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor=''
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor=''
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />

          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor=''
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
          <ShortcutButton
            label=''
            icon={null}
            badgeIcon={null}
            badgeCount={0}
            bgColor=''
            textColor='#000'
            width='113px'
            height='120px'
            onClick={() => {}}
            isOnProcess={true}
            isMini={true}
          />
        </GridSection2>
      </GridSection>
      <GridSection amount={2}>
        <ShortcutButton
          label={t('hr')}
          icon={null}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='113px'
          height='120px'
          iconwidth='113px'
          iconheight='57px'
          onClick={() => handleClickShortcut(t('hr'), '/hr')}
          isOnProcess={false}
          isMini={true}
        />
        <ShortcutButton
          label={t('incoming-documents')}
          icon={<IncomeDocsDarkIcon width='113px' height='57px' />}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='113px'
          height='120px'
          iconwidth='113px'
          iconheight='57px'
          onClick={() => handleClickShortcut(t('incoming-documents'), '/incoming-documents')}
          isOnProcess={false}
          isMini={true}
        />
        <ShortcutButton
          label={t('branches')}
          icon={null}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageInactiveShortcutButtonBackground}
          textColor={theme.mainPageInactiveShortcutButtonText}
          width='113px'
          height='120px'
          iconwidth='113px'
          iconheight='57px'
          onClick={() => handleClickShortcut(t('branches'), '/')}
          isOnProcess={true}
          isMini={true}
        />
        <ShortcutButton
          label={t('reports')}
          icon={null}
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageInactiveShortcutButtonBackground}
          textColor={theme.mainPageInactiveShortcutButtonText}
          width='113px'
          height='120px'
          iconwidth='113px'
          iconheight='57px'
          onClick={() => handleClickShortcut(t('reports'), '/')}
          isOnProcess={true}
          isMini={true}
        />
        <ShortcutButton
          label={t('data-library')}
          icon={
            // themeCookie === 'dark' ? (
            <CloudsDarkIcon width='64px' height='64px' />
            //   />
            // )
          }
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='113px'
          height='120px'
          onClick={() => handleClickShortcut(t('data-library'), '/data-library')}
          isOnProcess={false}
          isMini={true}
          iconwidth='64px'
          iconheight='64px'
        />
        <ShortcutButton
          label={t('finance')}
          icon={
            // themeCookie === 'dark' ? (
            <FundIcon width='64px' height='64px' />
            //   />
            // )
          }
          badgeIcon={null}
          badgeCount={0}
          bgColor={theme.mainPageActiveShortcutButtonBackground}
          textColor={theme.mainPageActiveShortcutButtonText}
          width='113px'
          height='120px'
          onClick={() => handleClickShortcut(t('finance'), '/finance')}
          isOnProcess={false}
          isMini={true}
          iconwidth='64px'
          iconheight='64px'
        />
      </GridSection>
    </GridContainer>
  )
}

export default HomeTop
